<template>
  <div>
    <div class="history-filter">
      <v-text-field v-model="filter" @input="isWritingComment = true" outline :placeholder="$t('production_history.filter')" clearable></v-text-field>
    </div>
    <div class="only-problems">
      <v-checkbox v-model="onlyProblems" :label="$t('production_history.only_problems')"></v-checkbox>
    </div>
    <div class="history-table">
      <div class="rTable">
        <div class="rTableRow">
          <div class="rTableHead" style="width:200px">{{$t('production_history.time')}}</div>
          <div class="rTableHead" style="width:100px">{{$t('production_history.order')}}</div>
          <div class="rTableHead" style="width:50px">{{$t('production_history.position')}}</div>
          <div class="rTableHead" style="width:200px">{{$t('production_history.work_center')}}</div>
          <div class="rTableHead" style="width: 150px">{{$t('production_history.worker')}}</div>
          <div class="rTableHead" style="width: 150px">{{$t('production_history.action')}}</div>
          <div class="rTableHead">{{$t('production_history.comment')}}</div>
        </div>
        <div class="rTableRow" v-for="(action, i) in actions" :key="i">
          <div class="rTableCell">{{action.time}}</div>
          <div class="rTableCell">{{action.order_name}}</div>
          <div class="rTableCell">{{action.position}}</div>
          <div class="rTableCell">{{getWorkCenterName(action.work_center_id)}}</div>
          <div class="rTableCell">{{action.user_name}}</div>
          <div class="rTableCell">{{getActionName(action.completed_action)}}</div>
          <div class="rTableCell">{{getComment(action.comment)}}</div>
        </div>
      </div>
    </div>
    <div class="text-xs-center history-pagination">
      <v-pagination v-model="page" :length="pages" @input="initialize"></v-pagination>
    </div>
  </div>
</template>

<script>
import Action from "@/models/Action.js";
export default {
  props: ["workCenters"],
  data() {
    return {
      onlyProblems: false,
      filter: "",
      actions: [],
      page: 1,
      pages: 1,
      isWritingComment: false
    };
  },
  watch: {
    filter() {
      clearTimeout(this.commentTimer);
      this.commentTimer = setTimeout(() => {
        this.isWritingComment = false;
      }, 500);
    },
    async isWritingComment(val) {
      if (!val) {
        this.initialize();
      }
    },
    onlyProblems(){
      this.initialize();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if(this.filter == ""){
        const { actions, pages } = await Action.getOperationsHistory(this.page, this.onlyProblems);
        this.pages = pages;
        this.actions = actions;
      } else {
        const {actions, pages} = await Action.getOperationsHistoryByOrder(this.filter, this.page, this.onlyProblems);
        this.pages = pages;
        this.actions = actions;
      }
    },

    getWorkCenterName(id) {
      const workCenter = this.workCenters.find(workCenter => {
        return workCenter.id == id;
      });
      return workCenter.toString();
    },

    getComment(comment) {
      return comment ? comment : "-";
    },

    getActionName(action) {
      switch (action) {
        case 0:
          return this.$t("production_history.comment");
        case 1:
          return this.$t("production_history.done");
        case 2:
          return this.$t("production_history.return");
        case 3:
          return this.$t("production_history.problem");
      }
    }
  }
};
</script>

<style scoped>
.rTable {
  display: table;
  width: 100%;
}
.rTableRow {
  display: table-row;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
}
.rTableCell,
.rTableHead {
  display: table-cell;
  padding: 0px 10px;
  border: 1px solid #999999;
}
.rTableHead {
  background: rgb(25, 118, 210);
  color: white;
}
.rTableHead:hover {
  cursor: pointer;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
  font-weight: bold;
}
.rTableFoot {
  display: table-footer-group;
  font-weight: bold;
  background-color: #ddd;
}
.rTableBody {
  display: table-row-group;
}
.history-table {
  position: absolute;
  left: 250px;
  width: calc(100% - 500px);
}
.history-pagination {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.history-filter{
  position: absolute;
  top: 10px;
  right: calc(100% - 240px);
  width: 200px;
}
.only-problems{
  position: absolute;
  left: 30px;
  top: 70px;
  right: calc(100% - 240px);
}
</style>